import { Outlet } from "react-router";
import type { LocaleHandle } from "~/app/lib/locale";

export const handle: LocaleHandle = { locale: "pl" };

export default function MarketingLayoutPL() {
  return <Outlet />;
}
